
import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface CalendarAddButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const CalendarAddButton: React.FC<CalendarAddButtonProps> = ({
  onClick,
  disabled
}) => {
  return (
    <Button 
      className="fixed bottom-6 right-6 sm:hidden rounded-full shadow-lg bg-blue-100 hover:bg-blue-200 text-primary"
      size="icon"
      onClick={onClick}
      disabled={disabled}
    >
      <Plus className="h-6 w-6" />
    </Button>
  );
};

export default CalendarAddButton;
